import React from "react";
import { formatCurrency } from "../utils/financialTransforms";

const SUMMARY_ITEMS = [
    { key: "totalIncome", label: "Total Income", icon: "💰" },
    { key: "totalExpenses", label: "Total Expenses", icon: "📉" },
    { key: "currentBalance", label: "Current Balance", icon: "💳" },
    { key: "transactionCount", label: "Number of Transactions", icon: "🔢", isCount: true },
    { key: "lastTransaction", label: "Last Transaction", icon: "📅", isDate: true },
];

export default function FinancialSummaryCards({ summary, loading }) {
    if (loading) {
        return (
            <div className="financial-summary-grid">
                {SUMMARY_ITEMS.map((item) => (
                    <div key={item.key} className="financial-summary-card skeleton-card">
                        <div className="skeleton skeleton-icon" />
                        <div className="skeleton skeleton-text short" />
                        <div className="skeleton skeleton-text" />
                    </div>
                ))}
            </div>
        );
    }

    if (!summary) return null;

    const { currency } = summary;

    return (
        <div className="financial-summary-grid">
            {SUMMARY_ITEMS.map((item) => {
                let value;
                if (item.isCount) {
                    value = summary.transactionCount;
                } else if (item.isDate) {
                    value = summary.lastTransaction;
                } else {
                    value = formatCurrency(summary[item.key], currency);
                }

                return (
                    <div key={item.key} className="financial-summary-card">
                        <span className="financial-summary-icon">{item.icon}</span>
                        <span className="financial-summary-label">{item.label}</span>
                        <span className="financial-summary-value">{value}</span>
                    </div>
                );
            })}
        </div>
    );
}
